import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, mergeClasses } from '@fluentui/react-components';
import { DeleteRegular, EditRegular, Dismiss24Regular } from '@fluentui/react-icons';
import { useInfoPaneHeaderStyle } from '../../styles';

export const InfoPaneHeader = ({
  isReadonly,
  i18n,
  title,
  onDelete,
  disableEdit,
  onEdit,
  dismiss,
}) => {
  const classes = useInfoPaneHeaderStyle();

  return (
    <div className={classes.detailHeader}>
      <div className={classes.panelTitle} role="heading" aria-level="2">{title}</div>
      <div className={classes.buttonBox}>
        <Button
          className={mergeClasses('delete-button', classes.deleteBox, classes.iconBox)}
          onClick={onDelete}
          aria-label="click to delete"
          disabled={isReadonly}
          title={i18n.getString(_TL_('Delete'))}
        >
          <DeleteRegular className={classes.icon} />
          <div className={classnames(classes.headerText, isReadonly && classes.disabledButton)}>{i18n.getString(_TL_('Delete'))}</div>
        </Button>

        { !disableEdit &&
          <Button
            className={classnames('edit-button', classes.editBox, classes.iconBox)}
            onClick={onEdit}
            aria-label="click to edit"
            title={i18n.getString(_TL_('Edit'))}
          >
            <EditRegular className={classes.icon} />
            <div className={classes.headerText}>{i18n.getString(_TL_('Edit'))}</div>
          </Button>
        }
        <Button
          className={classes.closeButton}
          appearance="subtle"
          aria-label="Close"
          icon={<Dismiss24Regular />}
          onClick={dismiss}
        />
      </div>
    </div>
  );
};

InfoPaneHeader.propTypes = {
  onDelete: PropTypes.func.isRequired,
  isReadonly: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,

  disableEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  dismiss: PropTypes.func.isRequired,
};

InfoPaneHeader.defaultProps = {
  isReadonly: false,
  disableEdit: false,
  onEdit: _.noop,
};
